import {
  FlatList,
  Text,
  TouchableOpacity,
  View,
  Pressable,
  Dimensions,
  ScrollView,
} from "react-native";
import NavBar from "../../../components/NavBar";
import BaseScreen from "../../BaseScreen";
import React, { useEffect, useState } from "react";
import { MainNavProps } from "../../navigation/main/MainParamList";
import { reload, useChatStore } from "../../../store/ChatStore";
import { postJson } from "../../../net/http";
import { showToast } from "../../../components/Toast";
import {
  Str_Admin_bold_font,
  Str_Admin_text_color,
  Str_Save,
  Str_SetSuc,
  Str_Special_message,
} from "../../../language/string_res";
import { white } from "../../../assets/style/colors";
import { CheckBoxView } from "../../../components/CheckBoxView";
import { ScreenCloseModal } from "../../../components/ScreenModal";
import { BottomButtonView } from "../../../components/BottomButtonView";
import { CommonSetting } from "../../../components/setting/CommonSetting";

type State = {
  isBold: string;
  color: string;
};
const colors = [
  "rgba(50,50,50,1)",
  "rgba(255,192,203,1)",
  "rgba(100,16,245,1)",
  "rgba(205,97,38,1)",
  "rgba(199,77,50,1)",
  "rgba(131,28,16,1)",
  "rgba(201,141,61,1)",
  "rgba(199,72,66,1)",
  "rgba(137,178,65,1)",
];
export const GroupChatFontSetting = ({
  navigation,
}: MainNavProps<"GroupChatFontSetting">) => {
  const { chatState, chatDispatch } = useChatStore();
  const NUM_COLUMNS = 5; // 5列宫格布局
  const ITEM_GAP = 8; // 间隙设为8
  const CONTAINER_PADDING = 16;
  const [parentWidth, setParentWidth] = useState(0);
  
  // 动态计算每个格子的大小
  const ITEM_SIZE = parentWidth > 0 ? (parentWidth - 2 * CONTAINER_PADDING - (NUM_COLUMNS - 1) * ITEM_GAP) / NUM_COLUMNS : 0;

  const group = chatState.curTopicWithSummary.group;
  const topic = chatState.curTopicWithSummary.topic;
  const [state, setState] = useState<State>({
    isBold: "",
    color: "",
  });

  useEffect(() => {
    const data: State = JSON.parse(group?.group_admin_special || "{}");
    let color = data.color || colors[0];
    let isBold = data.isBold;
    setState({
      isBold: isBold,
      color: color,
    });
  }, [group]);

  const handleSave = () => {
    let data = { isBold: state.isBold === "1" ? "1" : "0", color: state.color };
    const body = { tid: topic.tid, group_admin_special: JSON.stringify(data) };
    postJson<any>(`/v1/sdk/group/profile/set`, { body }).then((res: any) => {
      if (res.code === 0) {
        showToast(Str_SetSuc);
        reload(topic.tid, chatDispatch);
        navigation.pop();
      } else {
        setState({ ...state, isBold: state.isBold === "1" ? "0" : "1" });
      }
    });
  };

  const renderItem = ({ item, index }: { item: string; index: number }) => {
    const isLastColumn = (index + 1) % NUM_COLUMNS === 0;
    return (
      <Pressable
        style={[
          {
            backgroundColor: item,
            width: ITEM_SIZE,
            height: ITEM_SIZE,
            marginRight: isLastColumn ? 0 : ITEM_GAP,
            marginBottom: ITEM_GAP,
            justifyContent: "flex-end",
            alignItems: "flex-end",
            borderRadius: 4,
          },
        ]}
        onPress={() => setState({ ...state, color: item })}
      >
        {state.color === item && (
          <CheckBoxView
            value={true}
            style={{ width: 20, height: 20, marginRight: 5, marginBottom: 5 }}
          />
        )}
      </Pressable>
    );
  };

  return (
    <ScreenCloseModal title={Str_Special_message} offSetx={250}>
      <ScrollView showsVerticalScrollIndicator={false}>
        <CommonSetting
          style={{ marginHorizontal: 16, marginTop: 12, borderRadius: 0 }}
          itemOption={[
            {
              text: Str_Admin_bold_font,
              rightType: "Switch",
              switchIsEnabled: state.isBold === "1",
              setIsEnabled: (value) => setState({ ...state, isBold: value ? "1" : "0" }),
              switchChange: (value) => setState({ ...state, isBold: value ? "1" : "0" }),
            },
          ]}
        />

        <View
          style={{
            marginHorizontal: 16,
            marginTop: 12,
            backgroundColor: white,
            borderRadius: 8,
            padding: 16,
          }}
          onLayout={(e) => setParentWidth(e.nativeEvent.layout.width)}
        >
          <Text style={{ fontSize: 16, color: "#333", marginBottom: 12, fontWeight: "500" }}>
            {Str_Admin_text_color}
          </Text>
          <FlatList
            scrollEnabled={false}
            data={colors}
            keyExtractor={(item) => item}
            numColumns={NUM_COLUMNS}
            contentContainerStyle={{ paddingBottom: 8 }}
            columnWrapperStyle={{ justifyContent: 'flex-start' }}
            renderItem={renderItem}
          />
        </View>
      </ScrollView>
      <BottomButtonView text={Str_Save} onClick={handleSave} />
    </ScreenCloseModal>
  );
};
